import useGetAccessMember from '@fsd/entities/access/model/hooks/useGetAccessMember';
import { useMemo } from 'react';

export const useFilteredAccountMenu = (menuItems) => {
  const { permittedSections } = useGetAccessMember();

  const hasPermission = (requiredSection) => {
    if (!requiredSection) return true;
    return permittedSections?.includes(requiredSection);
  };

  const filtered = useMemo(() => {
    return menuItems
      .map((section) => {
        const visibleItems = section.items.filter((item) =>
          hasPermission(item.section)
        );

        if (visibleItems.length === 0) return null;

        return {
          ...section,
          items: visibleItems,
        };
      })
      .filter(Boolean); // удаляем пустые секции
  }, [menuItems, permittedSections]);

  return filtered;
};
